import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToggleIcon } from "../../assets/icon";
import { changeShowParameterGroup } from "../../redux/actions/Settings";
import {
  getActiveColorInGroup,
  getListColorInGroup,
} from "../../redux/selectors";
import { setConfiguration } from "../../utils/playcanvasChange";
import { ConfigColorItem } from "../ConfigColorItem/ConfigColorItem";

import s from "./SettingsGroup.module.scss";

export const SettingsGroup = ({ ...props }) => {
  const {
    setting,
    setting: { values },
    changeColor,
  } = props;

  const dispatch = useDispatch();

  const {
    Settings: { showSettingGroupId },
  } = useSelector((settings) => settings);

  const aciveColor = useSelector((state) => getActiveColorInGroup(state));
  const listColorInGroup = useSelector((state) => getListColorInGroup(state));

  const onToggle = (element_id) => {
    if (showSettingGroupId !== element_id) {
      dispatch(changeShowParameterGroup(element_id));
    } else {
      dispatch(changeShowParameterGroup(null));
    }
  };

  const onChangeItem = ({ id, name, assetId }) => {
    if (!window.configurator) return false;

    setConfiguration({
      propertyKey: setting.propertyKey,
      materialName: assetId || name,
    });
    dispatch(changeColor(id));
  };

  const isActiveGroup = showSettingGroupId === setting.id ? s.show : "";

  return (
    <div className={`${s.setting}  ${isActiveGroup} `}>
      <div className={s.setting_header} onClick={() => onToggle(setting.id)}>
        <div className={s.setting_name}>
          <div className="">{setting.name}</div>
        </div>
        <div className={s.info}>
          <div className={s.info_value}>
            <div className={s.info_value__name}>
              {setting?.infoActiveElement?.name}
            </div>
            <div className={s.info_value__img}>
              {setting?.infoActiveElement?.imgUrl ? (
                <img
                  src={setting?.infoActiveElement?.imgUrl}
                  alt={setting?.infoActiveElement?.alt}
                />
              ) : null}
            </div>
          </div>
          <div className={s.setting_header_toggle}>
            <ToggleIcon />
          </div>
        </div>
      </div>
      <div className={s.setting_main}>
        {listColorInGroup.map((item) => {

        
          return (
            item["visible"] && (
              <ConfigColorItem
                key={item.id}
                activeId={aciveColor?.id}
                item={item}
                onChangeItem={onChangeItem}
              />
            )
          );
        })}
      </div>
    </div>
  );
};
